import type { HandleClientError } from '@sveltejs/kit';
import { dev } from '$app/environment';
import { env } from '$env/dynamic/public';
import { initializeSplunkRum, useSplunkRum } from '$lib/services/tracking/splunk/splunkRum';
import { enableBrowserMock } from '$test_utils/mocks/enableBrowserMock';

initializeSplunkRum();

if (dev && env?.PUBLIC_ENABLE_BROWSER_MSW === 'true') {
	enableBrowserMock();
}

export const handleError: HandleClientError = async ({ error, event }) => {
	useSplunkRum((SplunkRum) => {
		SplunkRum.error(error, { extra: { event } });
	});
};
